//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { Button, Grid, InputLabel, TextField, Typography } from '@mui/material'
import React, { ReactElement, useEffect } from 'react'

import { theme } from '@react/components/theme'

import { useOtDispatch } from '@react/redux/store'
import { dynamicCreditDebitTx } from '@react/signedTxs/dynamicCreditDebit'

import { EthAddr } from '@shared/SchemaTypes'

export default function DynamicCreditDebitForm(props: { poolAddr: EthAddr; lenderAddr: EthAddr }): ReactElement {
  const { poolAddr, lenderAddr } = props

  const [creditValue, setCreditValue] = React.useState<string>('')
  const [debitValue, setDebitValue] = React.useState<string>('')
  const [errorMessage, setErrorMessage] = React.useState<string | null>()

  const [isSubmitted, setIsSubmitted] = React.useState(false)
  const sx = {
    backgroundColor: theme.palette.fg.main,
    color: '#FFFFFF',
    padding: '11px 16px 11px 16px',
    marginLeft: '8px',
    borderRadius: '6px',
    marginTop: 2,
  }

  useEffect(() => {
    errorCheck()
  }, [debitValue, creditValue])
  const dispatch = useOtDispatch()

  const creditDebitAction = (): void => {
    setIsSubmitted(true)

    const debit = BigInt(Math.round(Number(debitValue) * 1e6))
    const credit = BigInt(Math.round(Number(creditValue) * 1e6))
    dispatch(
      dynamicCreditDebitTx({
        poolAddr,
        lenderAddr,
        debit,
        credit,
      })
    )
    const event = new Event('modalClose')
    window.dispatchEvent(event)
  }
  const disableButton = errorMessage !== null
  const errorCheck = (): void => {
    if (Number(debitValue) != 0 && Number(creditValue) != 0) {
      setErrorMessage('Debit  and credit values can not both be set')
    } else if (Number(debitValue) < 0 || Number(creditValue) < 0) {
      setErrorMessage('Debit and credit values can not be negative')
    } else {
      setErrorMessage(null)
    }
  }

  return (
    <div data-testid="DebitCreditForm">
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Typography variant="body" align="left" sx={{ marginBottom: 2 }}>
            Debit or credit
          </Typography>
        </Grid>
      </Grid>
      <Grid container sx={{ marginTop: 2 }}>
        <Grid item xs={12}>
          <InputLabel htmlFor="assetValue">Credit Value</InputLabel>
          <TextField
            id="assetValue"
            inputProps={{
              'data-testid': 'assetValue',
            }}
            sx={{ width: '300px' }}
            variant="outlined"
            placeholder="Enter Credit amount"
            value={creditValue}
            type={'number'}
            onChange={(event: React.ChangeEvent<HTMLInputElement>): void => {
              setCreditValue(event.target.value)
              errorCheck()
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <InputLabel htmlFor="assetValue">Debit Value</InputLabel>
          <TextField
            id="assetValue"
            inputProps={{
              'data-testid': 'assetValue',
            }}
            sx={{ width: '300px' }}
            variant="outlined"
            placeholder="Enter Exchange Rate (Decimal Form)"
            value={debitValue}
            type={'number'}
            onChange={(event: React.ChangeEvent<HTMLInputElement>): void => {
              setDebitValue(event.target.value)
              errorCheck()
            }}
            onFocus={() => {
              errorCheck()
            }}
            onBlur={() => {
              errorCheck()
            }}
            helperText={errorMessage}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <Button
            disabled={isSubmitted || disableButton}
            sx={sx}
            onClick={() => {
              creditDebitAction()
            }}
            variant={'contained'}
          >
            <Typography variant={'buttonBold'}>Add the adjustment</Typography>
          </Button>
        </Grid>
        {disableButton && (
          <Typography variant="body" align="left" sx={{ marginBottom: 2 }}>
            specify either a credit or debit value
          </Typography>
        )}
      </Grid>
    </div>
  )
}
